import { ListPartFinderReportsResponse } from '@/api/generatedApi';
import { PART_FINDER_REPORTS_QUERY_KEY } from '@/hooks/api/part-finder-reports/query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';

const MAX_SIBLINGS = 1000;

export const useBatchReportSiblings = (batchId: string | undefined) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery<ListPartFinderReportsResponse, AxiosApiError>({
    queryKey: [PART_FINDER_REPORTS_QUERY_KEY, { tenantId, batchId, page: 1, perPage: MAX_SIBLINGS }],
    queryFn: async () => {
      const response = await api.tenants.listPartFinderReports(tenantId, 1, MAX_SIBLINGS, batchId);
      return response.data;
    },
    enabled: !!tenantId && !!batchId,
  });
};
